<template>
	<div>
		<MediaSettings
			v-if="widget.id === 'MEDIA'"
			:widget="widget"
			:widgetsAmount="widgetsAmount"
		/>
		<WebpageSettings
			v-if="widget.id === 'WEBPAGE'"
			:widget="widget"
			:widgetsAmount="widgetsAmount"
		/>
		<TextSettings
			v-if="widget.id === 'TEXT'"
			:widget="widget"
			:widgetsAmount="widgetsAmount"
		/>
		<MarqueeSettings
			v-if="widget.id === 'MARQUEE'"
			:widget="widget"
			:widgetsAmount="widgetsAmount"
		/>
		<WeatherSettings
			v-if="widget.id === 'WEATHER'"
			:widget="widget"
			:widgetsAmount="widgetsAmount"
		/>
		<CountdownSettings
			v-if="widget.id === 'COUNTDOWN'"
			:widget="widget"
			:widgetsAmount="widgetsAmount"
		/>
		<QRcodeSettings
			v-if="widget.id === 'QRCODE'"
			:widget="widget"
			:widgetsAmount="widgetsAmount"
		/>
		<YoutubeSettings
			v-if="widget.id === 'YOUTUBE'"
			:widget="widget"
			:widgetsAmount="widgetsAmount"
		/>
		<GoogleMapsSettings
			v-if="widget.id === 'GOOGLEMAPS'"
			:widget="widget"
			:widgetsAmount="widgetsAmount"
		/>
		<DateSettings
			v-if="widget.id === 'DATE'"
			:widget="widget"
			:widgetsAmount="widgetsAmount"
		/>
	</div>
</template>

<script>
export default {
    name: 'WidgetSettings',
	components: {
		DateSettings: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Widgets/Date/Settings'),
		GoogleMapsSettings: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Widgets/GoogleMaps/Settings'),
		MediaSettings: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Widgets/Media/Settings'),
		MarqueeSettings: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Widgets/Marquee/Settings'),
		WebpageSettings: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Widgets/Webpage/Settings'),
		WeatherSettings: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Widgets/Weather/Settings'),
		CountdownSettings: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Widgets/Countdown/Settings'),
		QRcodeSettings: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Widgets/QRcode/Settings'),
		TextSettings: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Widgets/Text/Settings'),
		YoutubeSettings: () => import( /* webpackPrefetch: true */ '@/views/Private/Components/Widgets/Youtube/Settings'),
	},
	props: {
		widget: Object,
		widgetsAmount: Number
	}
}
</script>
